import { PrevinetServiceType, ProductMacroCategory, usePrevinetLogic, walletPageMessages } from 'azshared';
import React, { Fragment, RefObject, useEffect, useRef, useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { AppErrorDialog } from '../../../../../components/dialog/app-error-dialog';
import { FinancialPositionsMacroCategoryItem } from './financial-position-macrocategory-item';

interface FinancialPositionsCardProps {
  macroCategories?: ProductMacroCategory[];
  flagShowBalance: boolean;
  goToRealEconomyDetailPage: () => void;
}

export const FinancialPositionsCard = (props: FinancialPositionsCardProps) => {
  const formRef: RefObject<HTMLFormElement> = useRef(null);
  const { macroCategories, flagShowBalance, goToRealEconomyDetailPage } = props;
  const { formatMessage } = useIntl();

  const hasRealEconomy = macroCategories?.some((cat) => cat.type === 'RealEconomy' && (cat.amount?.value > 0 || (cat.commitment?.value || 0) > 0));

  const { getPrevinetToken, getPrevinetUrl, previnetToken, clear, isRequestError } = usePrevinetLogic();
  const [previnetTargetUrl, setPrevinetTargetUrl] = useState(getPrevinetUrl(PrevinetServiceType.FondiPensione));

  const handleGoToPrevinet = useCallback(() => {
    setPrevinetTargetUrl(getPrevinetUrl(PrevinetServiceType.FondiPensione));
    getPrevinetToken(PrevinetServiceType.FondiPensione);
  }, [getPrevinetToken]);

  const handleGoToSustainableFuture = useCallback(() => {
    setPrevinetTargetUrl(getPrevinetUrl(PrevinetServiceType.SustainableFuture));
    getPrevinetToken(PrevinetServiceType.SustainableFuture);
  }, [getPrevinetToken]);

  useEffect(() => {
    if (previnetToken !== undefined) {
      formRef?.current?.submit();
      clear();
    }
  }, [clear, previnetToken]);

  return (
    <Fragment>
      <div className='financial-positions-card'>
        {macroCategories
          ?.filter((macroCategory) => {
            if (macroCategory.type === 'TotalFia') {
              return hasRealEconomy;
            }
            if (macroCategory.type === 'TotalPortfolio') {
              return hasRealEconomy;
            }
            return macroCategory.categories?.length;
          })
          .map((macroCategory, index) => (
            <div key={index}>
              <FinancialPositionsMacroCategoryItem
                key={index}
                macroCategory={macroCategory}
                flagShowBalance={flagShowBalance}
                onGoToPrevinet={handleGoToPrevinet}
                onGoToSustainableFuture={handleGoToSustainableFuture}
                goToRealEconomyDetailPage={goToRealEconomyDetailPage}
                allMacroCategories={macroCategories}
              />
            </div>
          ))}
      </div>
      <form ref={formRef} action={previnetTargetUrl} method='POST' encType='text/plain' style={{ display: 'none' }} target='_blank'>
        <input name={`{"access_token": "${previnetToken}"}`} />
      </form>
      <AppErrorDialog open={isRequestError} onClose={clear}>
        {formatMessage(walletPageMessages.errorDescriptionAccessPrevinet)}
      </AppErrorDialog>
    </Fragment>
  );
};
